import RedactionSearchOverlayContainer from './RedactionSearchOverlayContainer';

export default RedactionSearchOverlayContainer;